import React, { useEffect } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useOrderOrigins } from './../../hooks'
import { OrderOrigin } from './../../interfaces/OrderOrigin'

interface OrderOriginsDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  defaultLabel?: string
  isSearching?: boolean
  fullWidth?: boolean
  error?: boolean
  excludedOptions?: number[] // Nueva propiedad para excluir opciones seleccionadas
}

export const OrderOriginsDDL: React.FC<OrderOriginsDDLProps> = ({
  onChange,
  value,
  type,
  defaultLabel = 'Todos los origenes',
  isSearching = true,
  fullWidth = false,
  error = false,
  excludedOptions = [] // Inicializamos como un array vacío
}) => {
  const {
    orderOriginsState: { orderOrigins },
    getOrderOrigins
  } = useOrderOrigins()

  useEffect(() => {
    if (orderOrigins?.length === 0) {
      getOrderOrigins()
    }
  }, [])

  const filteredOrderOrigins =
    orderOrigins?.filter(
      (option: OrderOrigin) => !excludedOptions.includes(option.orderOriginId)
    ) || []

  // Asegurarse de que el valor actual siempre esté incluido
  const valueOption = orderOrigins?.find(
    (option) => option.orderOriginId === value
  )
  if (
    valueOption &&
    !filteredOrderOrigins.some(
      (o) => o.orderOriginId === valueOption.orderOriginId
    )
  ) {
    filteredOrderOrigins.push(valueOption)
  }

  const arrTypePositions = filteredOrderOrigins.map((option: OrderOrigin) => (
    <MenuItem key={option.orderOriginId} value={option.orderOriginId}>
      {option.origin}
    </MenuItem>
  ))

  return (
    <TextField
      variant={type}
      id='orderOriginId'
      name='orderOriginId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      error={error}
      helperText={error ? 'Debe seleccionar un origen de pedido' : undefined}
    >
      <MenuItem key={0} value={0}>
        {defaultLabel}
      </MenuItem>
      {isSearching && (
        <MenuItem key={-1} value={-1}>
          {'Pedidos sin origen'}
        </MenuItem>
      )}
      {arrTypePositions}
    </TextField>
  )
}
